var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocketGrowth1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5303 1.46967C18.2374 1.17678 17.7626 1.17678 17.4697 1.46967L14.4697 4.46967C14.1768 4.76256 14.1768 5.23744 14.4697 5.53033C14.7626 5.82322 15.2374 5.82322 15.5303 5.53033L17.25 3.81066V10C17.25 10.4142 17.5858 10.75 18 10.75C18.4142 10.75 18.75 10.4142 18.75 10V3.81066L20.4697 5.53033C20.7626 5.82322 21.2374 5.82322 21.5303 5.53033C21.8232 5.23744 21.8232 4.76256 21.5303 4.46967L18.5303 1.46967Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9975 2.371C13.2858 4.4258 14.5714 7.21271 14.5714 10.1186V16.3555L16.7367 17.3279C17.5109 17.6756 18 18.3862 18 19.1635V21.4869C18 21.7703 17.7441 22 17.4285 22H2.5715C2.25588 22 2 21.7703 2 21.4869V19.1635C2 18.3862 2.48906 17.6756 3.26332 17.3279L5.42857 16.3555V10.1186C5.42857 7.21271 6.71416 4.4258 9.00251 2.371C9.55341 1.87633 10.4466 1.87633 10.9975 2.371Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketGrowth1);
export default __webpack_public_path__ + "static/media/rocket-growth-1.d9bb49cc28e2755b9f7249b698399092.svg";
export { ForwardRef as ReactComponent };